import React from "react";
import { useSearchParams } from "react-router-dom";
import { Cog, Home, ListChecks } from "lucide-react";
import FieldOpsUnits from "@/pages/FieldOpsUnits";
import FieldOpsChecklists from "@/pages/FieldOpsChecklists";

const TABS = [{ k: "units", l: "Μονάδες", icon: Home }, { k: "checklists", l: "Checklists", icon: ListChecks }];

export default function FieldOpsSettings() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "units";
  return (
    <div className="space-y-6" data-testid="fo-settings-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-[#C86235]">Housekeeping</p>
        <h1 className="font-serif text-3xl md:text-4xl text-[#45423C] mt-1 inline-flex items-center gap-2"><Cog className="h-7 w-7" /> Ρυθμίσεις</h1>
      </div>
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.k} data-testid={`fo-settings-tab-${t.k}`} onClick={() => setParams({ tab: t.k })}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold border ${tab === t.k ? "bg-[#45423C] text-white border-[#45423C]" : "border-[#E3DED4] text-[#6F6A60] bg-white"}`}>
            <t.icon className="h-4 w-4" /> {t.l}
          </button>
        ))}
      </div>
      {tab === "units" ? <FieldOpsUnits embedded /> : <FieldOpsChecklists embedded />}
    </div>
  );
}
